
import { Options, Vue } from 'vue-class-component';
import { Inject } from 'vue-property-decorator';
import DesignerViewModel from '@/components/automation/flows/designer/DesignerViewModel';
import LegacyModal from '@/components/common/LegacyModal.vue';

@Options({
    props: {},
    components: {
        Modal: LegacyModal,
    },
})
export default class Toolbar extends Vue {
    @Inject() vm!: DesignerViewModel;

    save() {
        this.vm.flow.save();
    }
}
